import React, { lazy, Suspense } from 'react'
import { Box, Icon, Link, Text, Animation } from '@centra/centra-ui'
import lowerFirst from 'lodash/lowerFirst'

import styles from './TaskSurveyPopup.module.scss'
import { TaskSurveyFormData } from '../../../../store/taskManager/model'
import { TaskBasicInfo } from '../../../../effectorStores/taskSurvey/model'
import { TRANSITION_CLASSES } from './consts'

const TaskSurveyForm = lazy(() => import('./_Form'))

interface IProps {
  isOpenPopup: boolean
  isOpenForm: boolean
  task: TaskBasicInfo | null
  submitting: boolean
  onClose: () => void
  onSubmit: (data: TaskSurveyFormData) => void
}

const TaskSurveyPopup = ({ isOpenPopup, task, submitting, onClose, onSubmit, isOpenForm }: IProps) => {
  const isOpen = isOpenForm || isOpenPopup

  if (!isOpen || !task) return null

  return (
    <Animation open={isOpen} transitionClasses={TRANSITION_CLASSES}>
      <Box className={styles.root} column bgColor="basicWhite" alignItems="center" justifyContent="center">
        <Box fullWidth paddingLeft={48} paddingRight={48} justifyContent="center" paddingTop={16} paddingBottom={16}>
          <Text
            id="taskSurveyPopupTitle"
            className={styles.popupTitle}
            color="basicBlack"
            size="primary"
            weight="bold"
            noOfLines={3}
            align="center"
          >
            Оставьте отзыв по задаче{' '}
            <Link
              id="taskSurveyPopupLink"
              href={`/task/${task.id}`}
              target="_blank"
              textDecoration="underline"
              noStyles
            >
              {lowerFirst(task.name)}
            </Link>
          </Text>
        </Box>
        <Suspense fallback={null}>
          <TaskSurveyForm task={task} submitting={submitting} onSubmit={onSubmit} />
        </Suspense>
        <Icon name="close" size="md" className={styles.closeBtn} onClick={onClose} />
      </Box>
    </Animation>
  )
}

export default TaskSurveyPopup
